import './AnimatedBg.scss'

function AnimatedBg() {
   return (
      <div className="animated_bg"></div>
   );
}

export default AnimatedBg;